import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  SelectInput,
  required,
} from 'react-admin';
import { Grid } from '@mui/material';

const countryChoices = [
  { id: 'US', name: 'United States' },
  { id: 'Canada', name: 'Canada' },
];

export const ServiceProviderCreate = () => (
  <Create>
    <SimpleForm defaultValues={{ active: true }}>
      <Box sx={{ width: '100%', maxWidth: 800 }}>
        <Paper elevation={1} sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom color="primary" sx={{ mb: 3 }}>
            Service Provider Information
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextInput 
                source="name" 
                validate={[required()]} 
                fullWidth
                label="Business Name"
              />
            </Grid>
            <Grid item xs={12}>
              <TextInput 
                source="address" 
                fullWidth
                label="Address"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextInput 
                source="city" 
                fullWidth
                label="City"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextInput 
                source="provinceState" 
                fullWidth
                label="Province/State"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SelectInput 
                source="country" 
                choices={countryChoices}
                fullWidth
                label="Country"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextInput 
                source="phoneNumber" 
                fullWidth
                label="Phone Number"
              />
            </Grid>
            <Grid item xs={12}>
              <BooleanInput 
                source="active" 
                label="Active"
                helperText="Uncheck to deactivate this service provider"
              />
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </SimpleForm>
  </Create>
);